import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FilteredFaceDetailsParams } from '../../../features/private-campaign/services/face.service';
import { TagCategory, TagWithChild, UserTagsService } from '../../../services/user/userTags.service';
import { MatInputModule } from '@angular/material/input';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { ShutterService } from '../../../features/filter/shutter/services/shutter.service';
import { AlertService } from '../../../services/alert/alert.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialog } from '@angular/material/dialog';
import { FilterCategoryDialogComponent } from './filter-category-dialog/filter-category-dialog.component';
import { animate, state, style, transition, trigger } from '@angular/animations';


/**
 * Component global de filtre des écrans
 */
@Component({
    selector: 'wncm-screen-filter',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatChipsModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatMenuModule,
        MatTooltipModule,
        MatBadgeModule,
        FilterCategoryDialogComponent
    ],
    templateUrl: './wncm-screen-filter.component.html',
    styleUrl: './wncm-screen-filter.component.scss',
    animations: [
        trigger('openClose', [
            state('open', style({
                right: '0px',
                width: '100%',
            })),
            state('close', style({
                width: 0,
            })),
            transition('open <=> close', animate('2.3s ease-in-out'))
        ])
    ]
})
export class WncmScreenFilterComponent implements OnInit {
    //#region Variables

    @Output() public filterParamsChange = new EventEmitter<FilteredFaceDetailsParams>();


    @Input() public filterParams: FilteredFaceDetailsParams;

    /**
     * Recherch initial - utile pour affiche le 'close' dans le champ de recherche
     */
    public initSearch: string = null;
    public searchQuery: FormControl<any>;

    private readonly NB_ITEM_BY_PAGE = 20;
    /**
     * Selction des Tag avec nom, Category
     */
    selection: Map<string, TagCategory>;
    categoriesAndTag: TagCategory[];
    @ViewChildren('menuRef') menuList!: QueryList<MatMenu>;
    menuRefs = new Map<string, MatMenu>();

    @ViewChild('mobileSearchBar') mobileSearchBar;

    @Input()
    public shutterName = 'Filtrer vos écrans';

    public isDeviceIsdesktop: boolean = true;
    /**
     * Si `true` affichage du focus sur la barre de recherche en mode mobile
     */
    public isSearchingMobile: boolean = false;
    public displayMobileFilterPanel: boolean = false;

    //#endregion Variables

    // MARK: CONSTRUCTOR
    constructor(
        private readonly shutter$: ShutterService,
        private readonly alert$: AlertService,
        public dialog: MatDialog
    ) {
        this.filterParams = new FilteredFaceDetailsParams();
    }

    ngOnInit(): void {
        this.isDeviceIsdesktop = window.innerWidth > 900;
        this.searchQuery = new FormControl();
        // this.loadAllTags();
        this.initFilterParams();

    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        event?.preventDefault();
        this.isDeviceIsdesktop = window.innerWidth > 900;
    }

    ngAfterViewInit() {
        // Récupération de tous les tags dispos
        // this.loadAllTags();
    }



    public initFilterParams() {
        this.filterParams.page = 0;
        this.filterParams.pageSize = this.NB_ITEM_BY_PAGE;
        this.selection = UserTagsService.getTagsSelection(this.shutterName);
        this.filterParams.tags = UserTagsService.getSelectedTags(this.selection);
        this.filterParams.faceIds = UserTagsService.getSelectedTags(this.selection, 1);

    }

    onSearch() {
        this.filterParams.search = this.searchQuery.value;
        this.initSearch = this.searchQuery.value;

        //Trigger event searched
        this.filterParamsChange.emit(this.filterParams);

        if (this.isSearchingMobile) {
            this.hideSearchMobile();
        }
    }

    // onFilterMenuClosed() {
    //     this.initFilterParams()


    //     //trigger event menu closed
    //     if (this.menuChanged) {
    //         this.filterParamsChange.emit(this.filterParams);
    //         this.menuChanged = false;
    //     }
    // }

    getTagName(tagId: number) {
        if (tagId != null) {
            return UserTagsService.getTagName(tagId);
        }
    }

    getTagIcon(tagId: number) {
        return UserTagsService.getTagIcon(tagId);
    }

    removeTag(tagId: number) {
        UserTagsService.removeTagInSelection(this.shutterName, tagId);

        // remove in selection
        this.selection.forEach((tagCategory: TagCategory) => {
            let itemIndex: number = 0;
            tagCategory.t.forEach((child: TagWithChild) => {
                if (child.i === tagId) {
                    tagCategory.t.splice(itemIndex, 1);
                }
                else {
                    itemIndex++;
                }
            });
        });

        //Global Tags
        this.filterParams.tags = this.filterParams.tags.filter(
            (currentTagId) => {
                return currentTagId !== tagId;
            }
        );

        //Faces
        this.filterParams.faceIds = this.filterParams.faceIds.filter(
            (currentTagId) => {
                return currentTagId !== tagId;
            }
        );

        //trigger event tag removed
        this.filterParamsChange.emit(this.filterParams);
    }



    clearAllFilter() {
        UserTagsService.setTagsSelection(this.shutterName, []);
        this.filterParams.tags = [];
        this.filterParams.faceIds = [];
        this.searchQuery.setValue(null);
        this.selection = UserTagsService.getTagsSelection(this.shutterName);
        //trigger event tag removed
        this.filterParamsChange.emit(this.filterParams);
    }

    openFilterCategoryDialog() {

        if (this.isDeviceIsdesktop) {


            const filterDialogRef = this.dialog.open(FilterCategoryDialogComponent);


            filterDialogRef.componentInstance.shutterName = this.shutterName;

            filterDialogRef.afterClosed().subscribe((res) => {
                this.filterChanged(res);
            })
        } else {
            // //Mobile Mode
            // document.getElementById('mainToolbar').style.animationName = "toolbarAnimHide";

            // setTimeout(() => {

            document.getElementById('mainToolbar').style.visibility = 'hidden';
            document.getElementById('container').style.top = '0';
            // }, 0);

            // //Reload filters

            this.displayMobileFilterPanel = true;
        }
    }

    public filterChanged(emitChanges: boolean) {

        this.initFilterParams();
        if (emitChanges) {
            //trigger event menu closed
            this.filterParamsChange.emit(this.filterParams);

        }

        if (!this.isDeviceIsdesktop && this.displayMobileFilterPanel) {
            this.displayMobileFilterPanel = false;
            document.getElementById('mainToolbar').style.animationName = "toolbarAnimShow";
            setTimeout(() => {

                document.getElementById('mainToolbar').style.visibility = 'visible';
                document.getElementById('container').style.top = '80px';
            }, 0);
        }
    }

    focusMobile() {
        if (this.isDeviceIsdesktop) {
            // Not mobile

            return;
        } else {
            // Display search bar + opacitor
            this.isSearchingMobile = true;
            const mainToolbar = document.getElementById('mainToolbar');
            const mobileFilter = document.getElementById('mobileFilter');
            document.body.classList.add('modal-open'); // À l’ouverture
            const handleAnimationEnd = () => {
                if (mainToolbar != null) {
                    mainToolbar.style.visibility = 'hidden';
                    mainToolbar.style.opacity = '0';
                }

                if (mobileFilter != null) {
                    mobileFilter.style.top = "0";
                }
                setTimeout(() => {
                    this.mobileSearchBar?.nativeElement?.focus();
                }, 50);

            };

            if (mainToolbar != null) {
                mainToolbar.style.animationName = "toolbarAnimHide";
                mainToolbar.style.webkitAnimationName = "toolbarAnimHide";
                mainToolbar.addEventListener('animationend', handleAnimationEnd);
            }

            if (mobileFilter != null) {
                mobileFilter.style.animationName = "toolbarAnimHide";
                mobileFilter.style.webkitAnimationName = "toolbarAnimHide";
                mobileFilter.addEventListener('animationend', handleAnimationEnd);
            }
        }
    }

    hideSearchMobile() {
        this.isSearchingMobile = false;
        document.body.classList.remove('modal-open'); // À la fermeture

        const mainToolbar = document.getElementById('mainToolbar');
        const mobileFilter = document.getElementById('mobileFilter');

        const handleAnimationEnd = () => {
            if (mainToolbar != null) {
                mainToolbar.style.visibility = 'visible';
                mainToolbar.style.opacity = '1';
            }

            if (mobileFilter != null) {
                mobileFilter.style.top = "80px";
            }

        };

        if (mainToolbar != null) {
            mainToolbar.style.animationName = "toolbarAnimShow";
            mainToolbar.style.webkitAnimationName = "toolbarAnimShow";
            mainToolbar.addEventListener('animationend', handleAnimationEnd);
        }

        if (mobileFilter != null) {
            mobileFilter.style.animationName = "toolbarAnimShow";
            mobileFilter.style.webkitAnimationName = "toolbarAnimShow";
            mobileFilter.addEventListener('animationend', handleAnimationEnd);
        }
    }

    groupBy(id) {
        this.filterParams.groupBy = 1;
        this.filterParams.groupById = id;
        this.filterParamsChange.emit(this.filterParams);
    }
}
